<div class="flex justify-start mt-6">
  <div class="w-full">
    <div class="flex flex-col gap-2">
      <div class="py-2 pr-5 relative group">
        <sbnb-cs-debug-item
          *ngIf="message.uuid"
          label="copilot_message_uuid"
          [value]="message.uuid"></sbnb-cs-debug-item>

        <ng-container *ngFor="let block of message.data">
          <div *ngIf="block.type === ContentBlockType.Text">
            <div class="space-y-4" [innerHTML]="block.content | markdown | safe: 'html'"></div>
          </div>
          <div *ngIf="block.type === ContentBlockType.BarChart" class="mt-4">
            <ui-bar-chart [data]="block.data" [config]="{ title: block.data.title, height: 300 }"> </ui-bar-chart>
          </div>
          <div *ngIf="block.type === ContentBlockType.PieChart" class="mt-4">
            <ui-pie-chart [data]="block.data" [config]="{ title: block.data.title, height: 300 }"> </ui-pie-chart>
          </div>
        </ng-container>

        <!-- Yes/Cancel Buttons - Above the line -->
        <div class="flex justify-start mt-2" *ngIf="isLast && requiresConfirmation">
          <div class="flex items-center gap-2">
            <ui-button
              label="Yes"
              variant="primary"
              size="sm"
              (onClick)="onConfirmClick()"
              data-testid="copilot-confirm-button"></ui-button>
            <ui-button
              label="Cancel"
              variant="tertiary"
              size="sm"
              (onClick)="onCancelClick()"
              data-testid="copilot-cancel-button"></ui-button>
          </div>
        </div>

        <!-- Feedback Buttons -->
        <div class="flex items-center">
          <ui-button
            icon="griddy-thumbs-up"
            variant="quaternary"
            size="sm"
            [disabled]="!!feedback"
            [class.text-success-500]="feedback === 'liked'"
            (onClick)="onFeedbackClick(CopilotFeedbackRating.LIKE)"
            data-testid="copilot-like-button">
          </ui-button>
          <ui-button
            icon="griddy-thumbs-down"
            variant="quaternary"
            size="sm"
            [disabled]="!!feedback"
            [class.text-error-500]="feedback === 'disliked'"
            (onClick)="onFeedbackClick(CopilotFeedbackRating.DISLIKE)"
            data-testid="copilot-dislike-button">
          </ui-button>
          <sbnb-copy-to-clipboard
            [content]="textContent"
            [mini]="true"
            data-testid="copy-assistant-message"></sbnb-copy-to-clipboard>
        </div>
      </div>
    </div>
  </div>
</div>
